import { useGetList } from "ra-core";
import { Link } from "react-router";

import type { Contact, Task } from "../types";
import { isDone, isDueToday } from "./tasksPredicate";

export const DayList = () => {
  const { data: tasks = [], isPending } = useGetList<Task>("tasks", {
    pagination: { page: 1, perPage: 200 },
    sort: { field: "due_date", order: "ASC" },
  });
  const { data: contacts = [] } = useGetList<Contact>("contacts", {
    pagination: { page: 1, perPage: 200 },
    sort: { field: "last_name", order: "ASC" },
  });
  if (isPending) return null;

  const dueToday = tasks.filter(
    (task) =>
      !isDone({ ...task, done_date: task.done_date ?? null }) &&
      isDueToday(task.due_date),
  );

  return (
    <div className="mx-auto max-w-3xl">
      <h1 className="text-2xl font-semibold">Today</h1>
      <p className="mb-4 text-sm text-muted-foreground">Reminders due today.</p>
      {dueToday.length === 0 ? (
        <p className="text-sm text-muted-foreground">Nothing due today.</p>
      ) : (
        <ul className="space-y-3">
          {dueToday.map((task) => {
            const contact = contacts.find(
              (item) => item.id === task.contact_id,
            );
            const name = contact
              ? `${contact.first_name} ${contact.last_name}`
              : "Lead";
            return (
              <li key={task.id} className="rounded-xl border bg-card p-4">
                <p className="font-medium">{task.text}</p>
                <p className="text-sm text-muted-foreground">
                  {new Date(task.due_date).toLocaleString()}
                  {" · "}
                  <Link
                    className="text-sky-700 underline"
                    to={`/contacts/${task.contact_id}/show`}
                  >
                    {name}
                  </Link>
                </p>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

DayList.path = "/today";
